(function(){
  // Localised "Based on 2,400+ reviews" line (value/stars stay universal).
  var COUNT = {
    en: 'Based on 2,400+ reviews',
    fr: 'Sur la base de 2 400+ avis',
    de: 'Basierend auf 2.400+ Bewertungen',
    es: 'Basado en 2.400+ reseñas',
    it: 'Sulla base di 2.400+ recensioni',
    nl: 'Op basis van 2.400+ reviews',
    pt: 'Com base em 2.400+ avaliações'
  };

  function isHomepage() {
    // Strip trailing slash. Homepage = root '' OR just a locale segment like /fr-fr, /en, /en-gb.
    var p = location.pathname.replace(/\/+$/, '');
    return p === '' || /^\/[a-z]{2}(-[a-z]{2,})?$/i.test(p);
  }

  function countText() {
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return COUNT[lang] || COUNT.en;
  }

  function injectHeroRating() {
    if (!isHomepage()) return;
    if (document.querySelector('.fp-hero-rating')) return;

    var heroSection = document.querySelector('.fp-hero, slideshow-component, [class*="image-banner"], [class*="hero"]');
    if (!heroSection) heroSection = document.querySelector('main');
    if (!heroSection) return;

    var candidates = heroSection.querySelectorAll('h1, h2, h3, [class*="eyebrow"], [class*="subheading"], p');
    var eyebrow = null;
    var h1 = null;
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var txt = (el.textContent || '').trim();
      if (!h1 && el.tagName === 'H1' && txt.length > 0) h1 = el;
      if (!eyebrow && /home barista edit|the edit/i.test(txt)) eyebrow = el;
    }
    var anchor = eyebrow || h1;
    if (!anchor) return;

    var badge = document.createElement('div');
    badge.className = 'fp-hero-rating';
    badge.innerHTML = '<span class="fp-hero-rating__stars">★★★★★</span>' +
      '<span class="fp-hero-rating__value">4.9 / 5</span>' +
      '<span class="fp-hero-rating__sep">·</span>' +
      '<span class="fp-hero-rating__count">' + countText() + '</span>';

    anchor.insertAdjacentElement('beforebegin', badge);
  }

  function start() {
    injectHeroRating();
    if (document.querySelector('.fp-hero-rating')) return;
    var attempts = 0;
    var iv = setInterval(function() {
      attempts++;
      injectHeroRating();
      if (document.querySelector('.fp-hero-rating') || attempts > 20) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
